module.exports = __webpack_public_path__ + "am.svg?41e6105650bb108b46e153f4f043e027";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/am.svg
// module id = 968
// module chunks = 0